package de.oevbs.kunde.kundenportal2.services.consent

import de.oevbs.businesspartner.consent2.model.CustomerModel
import de.oevbs.businesspartner.consent2.stores.EditConsentStore
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.Handler
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class ConsentStore(job: Job) : EditConsentStore(job) {

    private val progressStore = storeOf(GeneralProgressStep.SUBMIT1, job)
    val progress: Flow<GeneralProgressStep> = progressStore.data

    private val initFailedStore = storeOf(false, job)
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    override val updateConsent: Handler<Unit> = handle { model ->
        GlobalServiceMessagesStore.clear()
        val success = globalSubmitTracker.track {
            saveConsent(model)
        }
        if (success) {
            progressStore.update(GeneralProgressStep.SUCCESS2)
        }
        model
    }

    override val loadCustomerModel: Handler<String> = handle { _, _ ->
        GlobalServiceMessagesStore.clear()
        globalInitTracker.track {
            val initData = initConsent()
            if (initData == null) {
                initFailedStore.update(true)
                return@track CustomerModel()
            }
            initData
        }
    }

    private suspend fun initConsent(): CustomerModel? {
        return tryCatchAndHandleErrors("Initialisieren der Einwilligungserklärung") {
            ConsentClient().init()
        }
    }

    private suspend fun saveConsent(model: CustomerModel): Boolean {
        tryCatchAndHandleErrors("Speichern der Einwilligungserklärung") {
            ConsentClient().save(model)
        } ?: return false
        return true
    }
}